import { T, Var } from 'gt-react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from 'src/components/ui/sheet';
import { AgentDefinitionBuilder } from 'src/pages/authenticated/agents/AgentDefinitionBuilder';

const PREVIEW_TABS: ('agent' | 'tools' | 'permissions')[] = [
  'agent',
  'tools',
  'permissions',
];

interface AgentPreviewSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  agentDefinitionId: string;
  stepLabel: string;
}

export function AgentPreviewSheet({
  open,
  onOpenChange,
  agentDefinitionId,
  stepLabel,
}: AgentPreviewSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="sm:max-w-3xl overflow-y-auto p-6">
        <SheetHeader>
          <SheetTitle>
            <T context="sheet title when viewing a background agent from a workflow node">
              Agent: <Var>{stepLabel}</Var>
            </T>
          </SheetTitle>
        </SheetHeader>
        <AgentDefinitionBuilder
          agentDefinitionId={agentDefinitionId}
          tabs={PREVIEW_TABS}
          hideHeader={false}
          hideActiveToggle
        />
      </SheetContent>
    </Sheet>
  );
}
